import React, { useState } from 'react';
import SecondaryNavBar from '../../../Components/SecondaryNavBar/SecondaryNavBar';
import LoadingOverlay from 'Components/LoadingOverlay/LoadingOverlay';
import { useSelector } from "react-redux";
import moment from "moment";
import { postChangementContrat } from "../../../api/modificationContratService";
import { getLabelInput } from "../../../utils/stringUtils";
import { checkInvalidDateEffet, renderError } from "../../../utils/formUtils";
import MessageInfoEnvoi from "../../../Components/Formulaire/MessageInfoEnvoi/MessageInfoEnvoi";

const CONF = window?.confPub;

export default function ChangementSituation(
    {
        isInside
    }
) {

    // TODO reprendre

    const {
        detailPersonne,
        contrat,
        contratsBeneficiaires,
        infosComplementaires,
        infosCorrespondant,
        keycloakReduce,
        referencesApp,
        loadingReferencesApp,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
        ...state.keycloakReducer,
        ...state.resourcesReducer,
    }))

    const UI = CONF?.UI
    const INPUTS = UI?.FORMULAIRES?.CHANGEMENT_SITUATION
    const COMMUN_INPUTS = CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS
    const BENEFICIAIRE_CHOISI = COMMUN_INPUTS?.BENEFICIAIRE_CHOISI
    const DATE_EFFET = COMMUN_INPUTS?.DATE_EFFET
    const LISTE_PRODUIT_SENOR_SANTE = UI?.FORMULAIRES?.LISTE_PRODUITS?.PRODUITS_SENOR_SANTE

    const CODES_FORMULAIRES = CONF?.CODES?.CODES_FORMULAIRES;
    const TYPE_INDIVIDU = CONF?.TYPE_INDIVIDU
    const PATTERNS = CONF?.PATTERNS

    const [disabledForm, setDisabledForm] = useState(false);
    const [submitted, setSubmitted] = useState(false)
    const [sendSuccess, setSendSuccess] = useState({
        isSuccess: false,
        message: false,
        display: false,
    })

    const initChangementSituationForm = {
        [BENEFICIAIRE_CHOISI?.NAME]: {
            name: BENEFICIAIRE_CHOISI?.NAME,
            value: '',
            invalid: BENEFICIAIRE_CHOISI?.ERRORS?.MANDATORY,
        },
        [DATE_EFFET?.NAME]: {
            name: DATE_EFFET?.NAME,
            value: '',
            invalid: DATE_EFFET?.ERRORS?.MANDATORY,
        },
        [INPUTS?.SITUATION?.NAME]: {
            name: INPUTS?.SITUATION?.NAME,
            value: '',
            invalid: INPUTS?.SITUATION?.ERRORS?.MANDATORY,
            complement: []
        },
        [INPUTS?.PRELEVEMENT?.NAME]: {
            name: INPUTS?.PRELEVEMENT?.NAME,
            value: 'NC',
            invalid: false,
        },
        [INPUTS?.DEPARTEMENT?.NAME]: {
            name: INPUTS?.DEPARTEMENT?.NAME,
            value: '',
            invalid: INPUTS?.DEPARTEMENT?.ERRORS?.MANDATORY
        },
        [INPUTS?.ETABLISSEMENT?.NAME]: {
            name: INPUTS?.ETABLISSEMENT?.NAME,
            value: '',
            invalid: INPUTS?.ETABLISSEMENT?.ERRORS?.MANDATORY
        },
        [INPUTS?.NUMERO_AGENT?.NAME]: {
            name: INPUTS?.NUMERO_AGENT?.NAME,
            value: '',
            invalid: INPUTS?.NUMERO_AGENT?.ERRORS?.MANDATORY
        },
        [INPUTS?.OPTION_PRODUIT_RETRAITE?.NAME]: {
            name: INPUTS?.OPTION_PRODUIT_RETRAITE?.NAME,
            value: 'NC',
            invalid: false,
        },
        [INPUTS?.PRECISION_AUTRE?.NAME]: {
            name: INPUTS?.PRECISION_AUTRE?.NAME,
            value: '',
            invalid: INPUTS?.PRECISION_AUTRE?.ERRORS?.MANDATORY
        },
    }

    const [changementSituationForm, setChangementSituationForm] = useState(initChangementSituationForm)

    const listeBeneficiaireMpCjt = contratsBeneficiaires.filter(({ typeIndividu }) => typeIndividu === TYPE_INDIVIDU?.MP?.CODE || typeIndividu === TYPE_INDIVIDU?.CJT?.CODE)

    const handleChangementSituation = (situation) => {

        console.log("situation")
        console.log(situation)

        setChangementSituationForm((prev) => ({
            ...prev,
            [INPUTS?.SITUATION?.NAME]: {
                ...prev?.[INPUTS?.SITUATION?.NAME],
                value: situation?.LABEL,
                code: situation?.CODE,
                invalid: false,
                complement: situation?.COMPLEMENT ?? []
            }
        }))
    }

    const handleInput = (e) => {

        const name = e?.target?.name
        const value = e?.target?.value
        const invalid = checkInput(name, value)

        setChangementSituationForm((prev) => ({
            ...prev,
            [name]: {
                ...prev?.[name],
                value: value,
                invalid: invalid,
            }
        }))
    }

    const checkInput = (name, value) => {
        const trimValue = typeof value === "string" ? value?.trim() : value
        let invalid = false

        switch (name) {

            case DATE_EFFET?.NAME:

                invalid = checkInvalidDateEffet(value)
                break

            case INPUTS?.SITUATION?.NAME:
            case INPUTS?.BENEFICIAIRE_CHOISI?.NAME:
            case INPUTS?.PRELEVEMENT?.NAME:
            case INPUTS?.DEPARTEMENT?.NAME:
            case INPUTS?.ETABLISSEMENT?.NAME:
            case INPUTS?.OPTION_PRODUIT_RETRAITE?.NAME:
            case INPUTS?.PRECISION_AUTRE?.NAME:
            case INPUTS?.NUMERO_AGENT?.NAME:

                if (!trimValue) {
                    invalid = "Champ obligatoire."

                }
                break
        }

        return invalid
    }
    const checkInvalidForm = () => {

        let invalid = false

        const fieldToControl = [
            BENEFICIAIRE_CHOISI?.NAME,
            DATE_EFFET?.NAME,
            INPUTS?.SITUATION?.NAME,
            ...changementSituationForm?.[INPUTS?.SITUATION?.NAME]?.complement,
            INPUTS?.PRELEVEMENT?.NAME
        ]

        fieldToControl?.forEach((field) => {


            const input = changementSituationForm?.[field]

            const invalidFiled = checkInput(input?.name, input?.value)

            invalid = invalidFiled ? invalidFiled : invalid
        })

        return invalid
    }

    const handleSubmit = async (e) => {

        e.preventDefault()
        setDisabledForm(true)

        const invalidForm = checkInvalidForm()

        if (!invalidForm) {

            const contratBeneficiaire = contratsBeneficiaires.find(({ idUniqueGrc }) => idUniqueGrc === changementSituationForm?.[BENEFICIAIRE_CHOISI?.NAME]?.value)
            const champ = [];

            champ.push(
                {
                    label: COMMUN_INPUTS?.NUM_CONTRAT?.LABEL_ENVOI,
                    valeur: detailPersonne?.contrat?.[0]?.numeroContrat
                },
                {
                    label: COMMUN_INPUTS?.NOM?.LABEL_ENVOI_MP,
                    valeur: detailPersonne?.nom
                },
                {
                    label: COMMUN_INPUTS?.PRENOM?.LABEL_ENVOI_MP,
                    valeur: detailPersonne?.prenom
                },
                {
                    label: BENEFICIAIRE_CHOISI?.LABEL_ENVOI,
                    valeur: `${ contratBeneficiaire?.civilite } ${ contratBeneficiaire?.prenom } ${ contratBeneficiaire?.nom } - ${ TYPE_INDIVIDU?.[contratBeneficiaire?.typeIndividu]?.LABEL } - né(e) le ${ contratBeneficiaire?.dateNaissance }`,
                },
                {
                    label: INPUTS?.SITUATION?.LABEL_ENVOI,
                    valeur: changementSituationForm?.[INPUTS?.SITUATION?.NAME]?.value
                },
                ...(changementSituationForm?.[INPUTS?.SITUATION?.NAME]?.complement?.length > 0
                    ? changementSituationForm?.[INPUTS?.SITUATION?.NAME]?.complement.map(complement => {

                        const inputRef = Object.values(INPUTS)?.find(({NAME}) => NAME === complement)
                        const refProduitSante = LISTE_PRODUIT_SENOR_SANTE?.find(({code}) => code === changementSituationForm?.[complement]?.value)

                        return (

                            {
                                label: inputRef?.LABEL_ENVOI,
                                valeur: `${ refProduitSante ? `${ refProduitSante?.label } ` : "" }${ changementSituationForm?.[complement]?.value !== "NC" ? changementSituationForm?.[complement]?.value : "" }`,
                            }
                        )
                    }) : []),
                {
                    label: INPUTS?.PRELEVEMENT?.LABEL_ENVOI,
                    valeur: changementSituationForm?.[INPUTS?.PRELEVEMENT?.NAME]?.value === "NC" ? "Non renseigné" : changementSituationForm?.[INPUTS?.PRELEVEMENT?.NAME]?.value,
                },
                {
                    label: DATE_EFFET?.LABEL_ENVOI,
                    valeur: moment(changementSituationForm?.[DATE_EFFET?.NAME]?.value, PATTERNS?.YYYY_DASH_MM_DASH_DD)
                        .format(PATTERNS?.DD_SLASH_MM_SLASH_YYYY)
                },
            )

            const codeQualification = changementSituationForm?.[INPUTS?.SITUATION?.NAME]?.code === "RETRAITE"
                ? CODES_FORMULAIRES?.SITUATION_RETIREMENT
                : CODES_FORMULAIRES?.SITUATION_UPDATE

            const formToSend = {
                idGrm: keycloakReduce?.decodedToken?.idGrm,
                idGrcDemandeur: infosCorrespondant?.idGrc,
                idGrcBeneficiaire: detailPersonne?.idPersGrc,
                codeDomaine: contrat?.gammeContrat,
                codeQualification: codeQualification,
                champ: champ
            }

            console.log("formToSend", formToSend)

            try {

                const resp = await postChangementContrat(formToSend)

                console.log("resp", resp)

                setSendSuccess({
                    isSuccess: true,
                    message: false,
                    display: true,
                })

                erasedInputs(false)

            } catch (err) {
                console.log("err", err);
                setSendSuccess({
                    isSuccess: false,
                    message: false,
                    display: true,
                })

                setSubmitted(true)

            } finally {
                setDisabledForm(false)
            }

        } else {
            setDisabledForm(false)
            setSubmitted(true)
        }
    }

    const erasedInputs = (all = false) => {

        setSubmitted(false)

        setChangementSituationForm(initChangementSituationForm)

        if (all) {
            setSendSuccess({
                isSuccess: false,
                message: false,
                display: false,
            })
        }
    }

    return (
        <div className="container mt-3">
            { !isInside && <SecondaryNavBar/> }
            <main id='content' className='overlay-container'>

                { disabledForm && <LoadingOverlay classes="upload-overlay"/> }

                <div className={ `${ !isInside ? 'col-lg-8' : '' }` }>
                    <div className="card">

                        <form onSubmit={ handleSubmit }>
                            <div className="card-header">
                                <h2>Changement de situation</h2>
                            </div>

                            <div className="card-body">

                                <div className={ 'form-label' }>
                                    { getLabelInput(BENEFICIAIRE_CHOISI) }
                                </div>

                                <div>
                                    { listeBeneficiaireMpCjt?.length > 0 && listeBeneficiaireMpCjt.map(contrat => (
                                        <div className="form-check" key={ contrat?.idUniqueGrc }>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name={ BENEFICIAIRE_CHOISI?.NAME }
                                                value={ contrat?.idUniqueGrc }
                                                checked={ changementSituationForm ?.[BENEFICIAIRE_CHOISI?.NAME]?.value === contrat?.idUniqueGrc }
                                                id={ contrat?.idUniqueGrc }
                                                onChange={ handleInput }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={ contrat?.idUniqueGrc }>
                                                { contrat?.civilite } { contrat?.prenom } { contrat?.nom }
                                            </label>
                                        </div>
                                    )) }

                                    { submitted && changementSituationForm?.[BENEFICIAIRE_CHOISI?.NAME]?.invalid
                                        && renderError(changementSituationForm?.[BENEFICIAIRE_CHOISI?.NAME]?.invalid) }
                                </div>

                                <div className="mt-4 col-lg-4">
                                    <label
                                        className={ 'form-label' }
                                        htmlFor={ DATE_EFFET?.NAME }>
                                        { getLabelInput(DATE_EFFET) }
                                    </label>
                                    <input
                                        id={ DATE_EFFET?.NAME }
                                        name={ DATE_EFFET?.NAME }
                                        className="form-control"
                                        value={ changementSituationForm?.[DATE_EFFET?.NAME]?.value }
                                        onChange={ handleInput }
                                        type="date"/>

                                    { submitted && changementSituationForm?.[DATE_EFFET?.NAME]?.invalid
                                        && renderError(changementSituationForm?.[DATE_EFFET?.NAME]?.invalid) }
                                </div>

                                <div className='mt-3'>

                                    <div className={ 'form-label' }>
                                        { getLabelInput(INPUTS?.SITUATION) }
                                    </div>
                                    { INPUTS?.SITUATION?.OPTIONS?.length > 0 && INPUTS?.SITUATION?.OPTIONS?.map(situation => (
                                        <div className="form-check" key={ situation?.CODE }>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name={ INPUTS?.SITUATION?.NAME }
                                                value={ situation?.CODE }
                                                checked={ changementSituationForm?.[INPUTS?.SITUATION?.NAME]?.code === situation?.CODE }
                                                id={ situation?.CODE }
                                                onChange={ () => handleChangementSituation(situation) }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={ situation?.CODE }>
                                                { situation?.LABEL }
                                            </label>
                                        </div>
                                    )) }

                                    { submitted && changementSituationForm?.[INPUTS?.SITUATION?.NAME]?.invalid
                                        && renderError(changementSituationForm?.[INPUTS?.SITUATION?.NAME]?.invalid) }
                                </div>

                                { changementSituationForm?.[INPUTS?.SITUATION?.NAME]?.complement?.length > 0
                                    && changementSituationForm?.[INPUTS?.SITUATION?.NAME]?.complement?.map((currentComplement) => {

                                        const refInput = Object.values(INPUTS).find(({ NAME }) => NAME === currentComplement)

                                        if (INPUTS?.OPTION_PRODUIT_RETRAITE?.NAME === currentComplement) {

                                            return (
                                                <div className="mt-3 col-lg-12" key={ currentComplement }>
                                                    <div className='form-label'>
                                                        { getLabelInput(refInput) }
                                                    </div>

                                                    <div>
                                                        { LISTE_PRODUIT_SENOR_SANTE?.length > 0 && LISTE_PRODUIT_SENOR_SANTE.map((produitSenor) => (
                                                            <div className="form-check" key={ produitSenor?.code }>
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name={ INPUTS?.OPTION_PRODUIT_RETRAITE?.NAME }
                                                                    value={ produitSenor?.code }
                                                                    checked={ changementSituationForm?.[INPUTS?.OPTION_PRODUIT_RETRAITE?.NAME]?.value === produitSenor?.code }
                                                                    id={ produitSenor?.code }
                                                                    onChange={ handleInput }
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={ produitSenor?.code }>
                                                                    { produitSenor?.label }
                                                                </label>
                                                            </div>
                                                        )) }
                                                    </div>

                                                    { submitted && changementSituationForm?.[INPUTS?.OPTION_PRODUIT_RETRAITE?.NAME]?.invalid
                                                        && renderError(changementSituationForm?.[INPUTS?.OPTION_PRODUIT_RETRAITE?.NAME]?.invalid) }
                                                </div>
                                            )
                                        } else if (currentComplement === INPUTS?.DEPARTEMENT?.NAME) {


                                            return (
                                                <div className="mt-4 col-lg-4" key={ INPUTS?.DEPARTEMENT?.NAME }>
                                                    <label
                                                        htmlFor={ INPUTS?.DEPARTEMENT?.NAME }
                                                        className='form-label'>
                                                        { getLabelInput(refInput) }
                                                    </label>
                                                    <select
                                                        name={ INPUTS?.DEPARTEMENT?.NAME }
                                                        className="form-select"
                                                        onChange={ handleInput }
                                                        value={ changementSituationForm?.[INPUTS?.DEPARTEMENT?.NAME]?.value}
                                                        aria-label="Default select example">
                                                        <option
                                                            key={ "" }
                                                            value={ "" }
                                                            disabled
                                                        >
                                                            { "Choisir" }
                                                        </option>
                                                        { !loadingReferencesApp && referencesApp?.departements?.map(option => (
                                                            <option
                                                                key={ option?.code }
                                                                value={ option?.code }
                                                            >
                                                                { option?.libelle }
                                                            </option>
                                                        )) }
                                                    </select>

                                                    { submitted && changementSituationForm?.[INPUTS?.DEPARTEMENT?.NAME]?.invalid
                                                        && renderError(changementSituationForm?.[INPUTS?.DEPARTEMENT?.NAME]?.invalid) }
                                                </div>
                                            )
                                        } else {
                                            return (
                                                <div className="mt-4 col-lg-4" key={ currentComplement }>
                                                    <label
                                                        htmlFor={ currentComplement }
                                                        className='form-label'>
                                                        { getLabelInput(refInput) }
                                                    </label>
                                                    <input
                                                        id={ currentComplement }
                                                        name={ currentComplement }
                                                        type="text"
                                                        value={ changementSituationForm?.[currentComplement]?.value }
                                                        onChange={ handleInput }
                                                        className='form-control'
                                                        placeholder={ refInput?.PLACEHOLDER }/>

                                                    { submitted && changementSituationForm?.[currentComplement]?.invalid
                                                        && renderError(changementSituationForm?.[currentComplement]?.invalid) }
                                                </div>
                                            )
                                        }
                                    }) }

                                <div className='mt-3'>
                                    <div className={ 'form-label' }>
                                        { getLabelInput(INPUTS?.PRELEVEMENT) }
                                    </div>
                                    <div>
                                        { INPUTS?.PRELEVEMENT?.OPTIONS?.length > 0 && INPUTS?.PRELEVEMENT?.OPTIONS.map(date => (
                                            <div className="form-check form-check-inline" key={ date?.CODE }>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name={ INPUTS?.PRELEVEMENT?.NAME }
                                                    value={ date?.CODE }
                                                    checked={ changementSituationForm?.[INPUTS?.PRELEVEMENT?.NAME]?.value === date?.CODE }
                                                    id={ date?.CODE }
                                                    onChange={ handleInput }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={ date?.CODE }>
                                                    { date?.LABEL }
                                                </label>
                                            </div>
                                        )) }
                                    </div>

                                    { submitted && changementSituationForm?.[INPUTS?.PRELEVEMENT?.NAME]?.invalid
                                        && renderError(changementSituationForm?.[INPUTS?.PRELEVEMENT?.NAME]?.invalid) }
                                </div>

                                <MessageInfoEnvoi
                                    isSuccess={ sendSuccess?.isSuccess }
                                    message={ sendSuccess?.message }
                                    display={ sendSuccess?.display }
                                />
                            </div>

                            <div className="card-footer">
                                <div className='d-flex justify-content-end'>
                                    <button
                                        type='submit'
                                        className="btn btn-primary"
                                    >
                                        Envoyer
                                    </button>
                                    <button
                                        type='button'
                                        onClick={ ()  => erasedInputs(true)}
                                        className="btn btn-secondary ms-2"
                                    >
                                        Effacer
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </div>
    )
}